module.exports = "//static.hsappstatic.net/connect-dot-com-public-ui/static-1.2998/images/highlightedMembers/illustrations/overlapping-circles.svg"